import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Row,
  Col
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

class ContactModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      editMode: false,
      warningModal: false,
      data: {
        parque: "",
        nombre: "",
        email: "",
        telefono: "",
        comentario: ""
      }
    };

    this.toggle = this.toggle.bind(this);
    this.send = this.send.bind(this);
    this.setFormData = this.setFormData.bind(this);
  }

  setFormData(event) {
    let editedCustomer = this.state.data;
    editedCustomer[event.target.name] = event.target.value;
    this.setState({ data: editedCustomer });
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  send() {
    this.toggle();
    this.props.send(this.state.data);

    this.setState({
      data: { parque: "", nombre: "", email: "", telefono: "", comentario: "" }
    });
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggle}>Formulario de contacto</ModalHeader>
          <ModalBody>
            <Form>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Parque</Label>
                    <Input
                      onChange={this.setFormData}
                      type="text"
                      name="parque"
                      id="parque"
                      value={this.state.data.parque}
                      placeholder="Parque / Empresa"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="examplePassword">Nombre</Label>
                    <Input
                      onChange={this.setFormData}
                      type="text"
                      name="nombre"
                      id="nombre"
                      value={this.state.data.nombre}
                      placeholder="Nombre"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Email</Label>
                    <Input
                      onChange={this.setFormData}
                      type="email"
                      name="email"
                      id="email"
                      value={this.state.data.email}
                      placeholder="Email"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="examplePassword">Teléfono</Label>
                    <Input
                      onChange={this.setFormData}
                      type="text"
                      name="telefono"
                      id="telefono"
                      value={this.state.data.telefono}
                      placeholder="Teléfono"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row form>
                <Col md={12}>
                  <FormGroup>
                    <Label for="examplePassword">Comentario</Label>
                    <Input
                      onChange={this.setFormData}
                      type="textarea"
                      name="comentario"
                      id="comentario"
                      value={this.state.data.comentario}
                      placeholder="Escríbemos aquí tu comentario"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggle}>
              Cancelar
            </Button>{" "}
            <Button
              color="secondary"
              onClick={() => {
                this.send();
              }}
            >
              Aceptar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default ContactModal;



// WEBPACK FOOTER //
// ./components/Header/contact-modal.js